module.exports = "/assets/festival-banners/listing-banner-gw-mobile.png?5hrMP/y";